<template>

      <span @click="speak()" class="text-to-speech">
        <font-awesome-icon icon="volume-up" />
          <!-- <button 
            id="play"
            class="play-btn"
            type="button"
            @click="speak()">Convert to speatch</button> -->
      </span>

</template>

<script>
export default {
  name: 'text-to-speech',
  props: [
    'inputText',
  ],
  data() {
    return {
      userInput: '',
      pitch: 1,
      rate: 0.9,
      synth: window.speechSynthesis,
      validation: false
    }
  },
  methods: {
    speak() {
      if ('speechSynthesis' in window) {
        if (this.synth.speaking) {
          console.error('speechSynthesis.speaking');
          return;
        }
        if (this.inputText !== '' || this.inputText == null) {
            this.validation = false;
            let sInstance = new SpeechSynthesisUtterance(this.inputText);
            // let voices = this.synth.getVoices();
            // sInstance.voice = voices[18];
            sInstance.lang = 'en-AU';

            sInstance.onend = function () {
                console.log('SpeechSynthesisUtterance.onend');
            }
            sInstance.onerror = function () {
                console.error('SpeechSynthesisUtterance.onerror');
            }

            sInstance.pitch = this.pitch;
            sInstance.rate = this.rate;
            this.synth.speak(sInstance);
        } else {
          this.validation = true;
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.text-to-speech {
  color: #bbb;
  transition: 0.3s;
  cursor: pointer;
  font-size: 22px;
  &:hover {
    color: green;
  }
}

</style>



